export enum Side {
  Base = "base",
  Quote = "quote",
}

export enum OrderType {
  Limit = "limit",
  Tracking = "tracking",
  Market = "market",
  Recurring = "recurring",
  Scale = "scale"
}
